import { CONTACT } from "./constants"

export interface CityData {
  id: number
  name: string
  slug: string
  state: string
  metaDescription: string
  keywords: string[]
  description: string
  coverageArea: string[]
  coordinates: { lat: number; lng: number }
  contactInfo: {
    phone: string
    email: string
    address: string
  }
  services: string[]
  localStats: {
    label: string
    value: string
  }[]
  faqs: Array<{ question: string; answer: string }>
  icon:string
  routes:string
}

// City images mapping
export const cityImages: Record<string, string> = {
  bhubaneswar: "/images/cities/bhubaneswar.jpeg",
  bangalore: "/images/cities/bangalore.jpg",
  pune: "/images/cities/pune.jpeg",
  mumbai: "/images/cities/mumbai.jpg",
  hyderabad: "/images/cities/hyderabad.jpg",
  delhi: "/images/cities/delhi.jpeg",
  kolkata: "/images/cities/kolkata.jpeg",
  chennai: "/images/cities/chennai.jpg",
}

export const cityData: CityData[] = [
  {
    id: 1,
    name: "Bhubaneswar",
    slug: "bhubaneswar",
    state: "Odisha",
    routes: "150+ Routes",
    icon: cityImages.bhubaneswar,
    metaDescription:
      "Packers & movers in Bhubaneswar. Bigwin Relocation offers professional moving, packing, and storage services in Bhubaneswar and surrounding areas of Odisha.",
    keywords: ["packers and movers in bhubaneswar", "movers in bhubaneswar", "relocation bhubaneswar", "moving services bhubaneswar"],
    description:
      "Bigwin Relocation is your trusted moving partner in Bhubaneswar. With extensive experience in household and corporate relocations, we ensure stress-free moving experiences across Bhubaneswar, Cuttack, and surrounding areas.",
    coverageArea: ["Bhubaneswar", "Cuttack", "Puri", "Khordha", "Nayagarh"],
    coordinates: { lat: 20.2961, lng: 85.8245 },
    contactInfo: {
      phone: CONTACT.phone.display,
      email: CONTACT.email.primary,
      address: "Bhubaneswar, Odisha, India",
    },
    services: ["Household Shifting", "Office Shifting", "Local Shifting", "Car Shifting", "Motorcycle Shifting", "Pet Relocation"],
    localStats: [
      { label: "Relocations", value: "2500+" },
      { label: "Satisfaction Rate", value: "98%" },
      { label: "Years Experience", value: "8+" },
      { label: "On-Time Delivery", value: "99%" },
    ],
    faqs: [
      {
        question: "How long does a move within Bhubaneswar take?",
        answer: "Local moves within Bhubaneswar typically take 1-2 days depending on the volume of items and distance.",
      },
      {
        question: "Do you provide storage in Bhubaneswar?",
        answer: "Yes, we have secure storage facilities in Bhubaneswar for short-term and long-term needs.",
      },
      {
        question: "Are your packers trained and insured?",
        answer: "Yes, all our staff are trained professionals with comprehensive insurance coverage for your belongings.",
      },
      {
        question: "Do you move to other cities from Bhubaneswar?",
        answer: "Yes, we provide intercity relocation services from Bhubaneswar to all major cities across India.",
      },
    ],
  },
  {
    id: 2,
    name: "Bangalore",
    slug: "bangalore",
    state: "Karnataka",
    routes: "300+ Routes",
    icon: cityImages.bangalore,
    metaDescription:
      "Packers & movers in Bangalore. Bigwin Relocation offers professional moving and relocation services in Bangalore with ISO certification and 24/7 support.",
    keywords: [
      "packers and movers in bangalore",
      "movers in bangalore",
      "relocation bangalore",
      "moving services bangalore",
    ],
    description:
      "Bigwin Relocation brings professional moving services to Bangalore. We handle residential, commercial, and specialized moves with utmost care across all areas of Bangalore.",
    coverageArea: ["Bangalore", "Whitefield", "Koramangala", "HSR Layout", "Electronic City", "Marathahalli", "Indiranagar"],
    coordinates: { lat: 12.9716, lng: 77.5946 },
    contactInfo: {
      phone: CONTACT.phone.display,
      email: CONTACT.email.primary,
      address: "Bangalore, Karnataka, India",
    },
    services: ["Household Shifting", "Office Shifting", "Local Shifting", "International Moving", "Car Shifting", "Bulk Shifting"],
    localStats: [
      { label: "Relocations", value: "5000+" },
      { label: "Satisfaction Rate", value: "99%" },
      { label: "Years Experience", value: "10+" },
      { label: "On-Time Delivery", value: "99.5%" },
    ],
    faqs: [
      {
        question: "Do you provide moving services within Bangalore outskirts?",
        answer: "Yes, we cover Bangalore city and surrounding areas including Whitefield, Electronic City, and all major tech parks.",
      },
      {
        question: "What is the average cost of moving in Bangalore?",
        answer: "Costs vary based on distance and volume. Local moves start from ₹5,000. Contact us for a free customized quote.",
      },
      {
        question: "Can you move office equipment safely?",
        answer: "Yes, we have specialized teams for office and IT equipment relocations with proper handling and insurance.",
      },
      {
        question: "Do you work on weekends?",
        answer: "Yes, we operate 7 days a week including weekends and holidays for your convenience.",
      },
    ],
  },
  {
    id: 3,
    name: "Pune",
    slug: "pune",
    state: "Maharashtra",
    routes: "250+ Routes",
    icon: cityImages.pune,
    metaDescription:
      "Packers & movers in Pune. Bigwin Relocation offers affordable and reliable moving services in Pune and surrounding areas with transparent pricing.",
    keywords: ["packers and movers in pune", "movers in pune", "relocation pune", "moving services pune"],
    description:
      "Moving to or within Pune? Bigwin Relocation provides professional moving services at competitive rates with full transparency and zero hidden charges.",
    coverageArea: ["Pune", "Pimpri-Chinchwad", "Hinjewadi", "Wakad", "Kharadi", "Hadapsar"],
    coordinates: { lat: 18.5204, lng: 73.8567 },
    contactInfo: {
      phone: CONTACT.phone.display,
      email: CONTACT.email.primary,
      address: "Pune, Maharashtra, India",
    },
    services: ["Household Shifting", "Office Shifting", "Local Shifting", "Car Shifting", "Motorcycle Shifting", "Pet Relocation"],
    localStats: [
      { label: "Relocations", value: "4200+" },
      { label: "Satisfaction Rate", value: "98%" },
      { label: "Years Experience", value: "9+" },
      { label: "On-Time Delivery", value: "99.2%" },
    ],
    faqs: [
      {
        question: "How quickly can you complete a move in Pune?",
        answer: "We can typically complete a local move in Pune within 1-2 days depending on the volume of items.",
      },
      {
        question: "Do you move vehicles as well?",
        answer: "Yes, we provide specialized car and motorcycle shifting services with door-to-door delivery.",
      },
      {
        question: "Are there extra charges for weekend moves?",
        answer: "Weekend moves are available at standard rates without additional charges.",
      },
      {
        question: "Do you provide packing materials?",
        answer: "Yes, we provide all premium packing materials including boxes, bubble wrap, and protective covers.",
      },
    ],
  },
  {
    id: 4,
    name: "Mumbai",
    slug: "mumbai",
    state: "Maharashtra",
    routes: "400+ Routes",
    icon: cityImages.mumbai,
    metaDescription:
      "Packers & movers in Mumbai. Bigwin Relocation provides professional moving services in Mumbai, Thane, Navi Mumbai with 24/7 support and insurance coverage.",
    keywords: ["packers and movers in mumbai", "movers in mumbai", "relocation mumbai", "moving services mumbai"],
    description:
      "Experience seamless relocations in Mumbai with Bigwin Relocation. We specialize in household, corporate, and international moves across Mumbai and surrounding regions.",
    coverageArea: ["Mumbai", "Thane", "Navi Mumbai", "Kalyan", "Panvel"],
    coordinates: { lat: 19.076, lng: 72.8777 },
    contactInfo: {
      phone: CONTACT.phone.display,
      email: CONTACT.email.primary,
      address: "Mumbai, Maharashtra, India",
    },
    services: ["Household Shifting", "Office Shifting", "International Moving", "Local Shifting", "Car Shifting", "Bulk Shifting"],
    localStats: [
      { label: "Relocations", value: "6000+" },
      { label: "Satisfaction Rate", value: "99%" },
      { label: "Years Experience", value: "11+" },
      { label: "On-Time Delivery", value: "99.8%" },
    ],
    faqs: [
      {
        question: "What areas in Mumbai do you cover?",
        answer:
          "We cover all major areas in Mumbai including South Mumbai, Central Mumbai, Western suburbs, Eastern suburbs, Thane, and Navi Mumbai.",
      },
      {
        question: "Do you handle high-rise apartment moves?",
        answer: "Yes, we have specialized teams and equipment for high-rise apartment relocations with proper safety measures.",
      },
      {
        question: "Is weekend moving available?",
        answer: "Yes, we offer weekend and holiday moving options at standard rates without extra charges.",
      },
      {
        question: "Do you provide international moving from Mumbai?",
        answer: "Yes, we handle international relocations with complete documentation and customs clearance support.",
      },
    ],
  },
  {
    id: 5,
    name: "Hyderabad",
    slug: "hyderabad",
    state: "Telangana",
    routes: "280+ Routes",
    icon: cityImages.hyderabad,
    metaDescription:
      "Packers & movers in Hyderabad. Bigwin Relocation provides professional moving services in Hyderabad with expert handling, ISO certification, and 24/7 support.",
    keywords: [
      "packers and movers in hyderabad",
      "movers in hyderabad",
      "relocation hyderabad",
      "moving services hyderabad",
    ],
    description:
      "Trust Bigwin Relocation for your moves in Hyderabad. We provide comprehensive relocation services for families and businesses across all areas of Hyderabad.",
    coverageArea: ["Hyderabad", "Secunderabad", "HITEC City", "Gachibowli", "Jubilee Hills", "Madhapur", "Kukatpally"],
    coordinates: { lat: 17.385, lng: 78.4867 },
    contactInfo: {
      phone: CONTACT.phone.display,
      email: CONTACT.email.primary,
      address: "Hyderabad, Telangana, India",
    },
    services: ["Household Shifting", "Office Shifting", "Local Shifting", "Car Shifting", "Motorcycle Shifting", "Pet Relocation"],
    localStats: [
      { label: "Relocations", value: "4500+" },
      { label: "Satisfaction Rate", value: "98%" },
      { label: "Years Experience", value: "9+" },
      { label: "On-Time Delivery", value: "99.3%" },
    ],
    faqs: [
      {
        question: "Are your movers experienced with IT hub relocations?",
        answer: "Yes, we specialize in corporate relocations and have successfully moved numerous IT companies in HITEC City and Gachibowli.",
      },
      {
        question: "Do you provide temporary storage?",
        answer: "Yes, we offer flexible short-term and long-term storage solutions with climate-controlled facilities.",
      },
      {
        question: "What insurance options are available?",
        answer: "We offer comprehensive insurance coverage options to protect your belongings during transit.",
      },
      {
        question: "Can you handle same-day local moves?",
        answer: "Yes, we offer same-day local shifting services within Hyderabad based on availability.",
      },
    ],
  },
  {
    id: 6,
    name: "Delhi",
    slug: "delhi",
    state: "Delhi",
    routes: "500+ Routes",
    icon: cityImages.delhi,
    metaDescription:
      "Packers & movers in Delhi NCR. Bigwin Relocation offers professional moving, packing, and storage services in Delhi, Noida, Gurgaon, and surrounding areas.",
    keywords: ["packers and movers in delhi", "movers in delhi ncr", "relocation delhi", "moving services delhi"],
    description:
      "Bigwin Relocation is your trusted moving partner in Delhi NCR. With extensive experience in household and corporate relocations, we ensure stress-free moving experiences across Delhi, Noida, Gurgaon, and Faridabad.",
    coverageArea: ["Delhi", "Noida", "Gurgaon", "Faridabad", "Greater Noida", "Ghaziabad"],
    coordinates: { lat: 28.7041, lng: 77.1025 },
    contactInfo: {
      phone: CONTACT.phone.display,
      email: CONTACT.email.primary,
      address: "New Delhi, India",
    },
    services: ["Household Shifting", "Office Shifting", "Local Shifting", "International Moving", "Car Shifting", "Bulk Shifting"],
    localStats: [
      { label: "Relocations", value: "7000+" },
      { label: "Satisfaction Rate", value: "99%" },
      { label: "Years Experience", value: "11+" },
      { label: "On-Time Delivery", value: "99.7%" },
    ],
    faqs: [
      {
        question: "How long does a move within Delhi NCR take?",
        answer: "Local moves within Delhi NCR typically take 1-2 days depending on the volume of items and distance.",
      },
      {
        question: "Do you provide storage in Delhi?",
        answer: "Yes, we have climate-controlled storage facilities across Delhi NCR for short and long-term needs.",
      },
      {
        question: "Are your packers trained and insured?",
        answer: "Yes, all our staff are trained professionals with comprehensive insurance coverage.",
      },
      {
        question: "Do you handle international relocations from Delhi?",
        answer: "Yes, we provide complete international moving services with documentation and customs support.",
      },
    ],
  },
  {
    id: 7,
    name: "Kolkata",
    slug: "kolkata",
    state: "West Bengal",
    routes: "200+ Routes",
    icon: cityImages.kolkata,
    metaDescription:
      "Packers & movers in Kolkata. Bigwin Relocation offers professional moving services in Kolkata with experienced staff, full insurance, and 24/7 support.",
    keywords: ["packers and movers in kolkata", "movers in kolkata", "relocation kolkata", "moving services kolkata"],
    description:
      "Kolkata moving made easy with Bigwin Relocation. We provide reliable and affordable relocation services for families and businesses across Kolkata and surrounding areas.",
    coverageArea: ["Kolkata", "Salt Lake", "New Town", "Rajarhat", "Howrah", "Dum Dum"],
    coordinates: { lat: 22.5726, lng: 88.3639 },
    contactInfo: {
      phone: CONTACT.phone.display,
      email: CONTACT.email.primary,
      address: "Kolkata, West Bengal, India",
    },
    services: ["Household Shifting", "Office Shifting", "Local Shifting", "Car Shifting", "Motorcycle Shifting", "Pet Relocation"],
    localStats: [
      { label: "Relocations", value: "3500+" },
      { label: "Satisfaction Rate", value: "97%" },
      { label: "Years Experience", value: "8+" },
      { label: "On-Time Delivery", value: "98.5%" },
    ],
    faqs: [
      {
        question: "Do you move fragile items like pottery and handicrafts?",
        answer: "Yes, we have specialized packing materials and techniques for fragile and delicate items.",
      },
      {
        question: "What is your service area in Kolkata?",
        answer: "We serve all of Kolkata city and surrounding areas including Salt Lake, New Town, Howrah, and Rajarhat.",
      },
      {
        question: "Can you handle antique furniture moves?",
        answer: "Yes, we have expert handlers trained in moving antique and valuable furniture with special care.",
      },
      {
        question: "Do you provide same-day moving services?",
        answer: "Yes, we offer same-day local shifting services in Kolkata based on availability.",
      },
    ],
  },
  {
    id: 8,
    name: "Chennai",
    slug: "chennai",
    state: "Tamil Nadu",
    routes: "220+ Routes",
    icon: cityImages.chennai,
    metaDescription:
      "Packers & movers in Chennai. Bigwin Relocation provides professional moving and storage services in Chennai with ISO certification and transparent pricing.",
    keywords: ["packers and movers in chennai", "movers in chennai", "relocation chennai", "moving services chennai"],
    description:
      "Bigwin Relocation serves Chennai with professional moving services. We handle all types of relocations with care, efficiency, and complete transparency.",
    coverageArea: ["Chennai", "Velachery", "Kodambakkam", "Anna Nagar", "Tambaram", "OMR", "Porur"],
    coordinates: { lat: 13.0827, lng: 80.2707 },
    contactInfo: {
      phone: CONTACT.phone.display,
      email: CONTACT.email.primary,
      address: "Chennai, Tamil Nadu, India",
    },
    services: ["Household Shifting", "Office Shifting", "Local Shifting", "Car Shifting", "Motorcycle Shifting", "Pet Relocation"],
    localStats: [
      { label: "Relocations", value: "4000+" },
      { label: "Satisfaction Rate", value: "98%" },
      { label: "Years Experience", value: "9+" },
      { label: "On-Time Delivery", value: "99.1%" },
    ],
    faqs: [
      {
        question: "Do you handle monsoon-season moves in Chennai?",
        answer: "Yes, we have special protocols and waterproof packing materials for monsoon moves to protect your belongings.",
      },
      {
        question: "What areas in Chennai do you service?",
        answer: "We cover all major areas in Chennai including North, South, Central Chennai, OMR, and surrounding suburbs.",
      },
      {
        question: "Do you provide unpacking services?",
        answer: "Yes, unpacking and setup services are available as add-ons to make your move completely hassle-free.",
      },
      {
        question: "Can you move during weekends?",
        answer: "Yes, we operate 7 days a week including weekends and holidays at standard rates.",
      },
    ],
  },
]
